import { Link } from "react-router-dom";
import Logo from "../assets/images/home-white.svg";
import { FaPhone } from "react-icons/fa6";
import { FaFacebook } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa";
const Footer = () => {
  return (
    <>
      <div className="b-ftr"></div>
      <div className="common-space pb-1 ftr">
        <div className="container-fluid mb-5">
          <div className="row">
            <div className="col-md-4">
              <Link to="/">
                <div className="d-flex align-items-center">
                  <img src={Logo} alt="logo" />
                  <h2 className="logo-text text-white">Söder Renovering</h2>
                </div>
              </Link>
              <p className="ftr-text my-5">
                Varmt välkommen till oss på Söder Renovering AB! Vi har
                tillhandahållit exklusiva och eleganta renoveringslösningar i
                Stockholmsområdet i över 10 års tid.
              </p>
              <Link to="tel:0704872068" className="ftr-text">
                <FaPhone className="me-3" /> 070 487 20 68
              </Link>
            </div>

            <div className="col-md-4 d-flex justify-content-center">
              <div className="ftr-second-sec">
                <h6 className="ftr-small-title">Länkar</h6>
                <div className="ftr-link">
                  <Link to="/">Hem</Link>
                </div>
                {/* <div className="ftr-link">
                                    <Link to="/renovation">
                                        Projekt</Link>
                                </div> */}
                <div className="ftr-link">
                  <Link to="/services">Tjänster</Link>
                </div>
                <div className="ftr-link">
                  <Link to="/about">Om oss</Link>
                </div>

                <div className="ftr-link">
                  <Link to="/contact">Kontakt</Link>
                </div>
                <div className="ftr-link">
                  <Link to="/contact"> Bygga Hus i Söder Renovering</Link>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <h6 className="ftr-small-title">Contact Info</h6>
              <div className="ftr-link">
                <Link>
                  Söder Renovering AB
                  <br />
                  Medborgarplatsen 11
                  <br />
                  118 26 Stockholm
                  <br />
                  Stockholms Län
                  <br />
                </Link>
              </div>
              <div className="ftr-link">
                <Link>Org.nr: 559421-1640</Link>
              </div>
            </div>
          </div>
        </div>

        <hr className="border-white" />

        <div className="my-2">
          <p className="text-center d-flex gap-4 justify-content-center">
            <Link
              className="nav-right-icons"
              target="_blank"
              to="https://www.facebook.com/profile.php?id=100095169007059"
            >
              <FaFacebook />
            </Link>
            <Link
              target="_blank"
              to="https://www.instagram.com/soderrenovering/"
              className="nav-right-icons"
            >
              <FaInstagram />
            </Link>

            <Link
              className="nav-right-icons"
              target="_blank"
              to="https://www.tiktok.com/@soderrenovering?is_from_webapp=1&sender_device=pc"
            >
              <FaTiktok />
            </Link>
          </p>
        </div>
      </div>
    </>
  );
};

export default Footer;
